
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { Message } from "element-ui";
import {
  createCustomerWhole,
  searchCustomerAll,
  getCustomer,
  deleteCustomer,
  uploadCustomer, getCustomerEdit, uploadCustomerPriceClass, getAllPriceClass
} from "@/api/customer";
import ContainerTypeReleasedInfo from "@/views/components/ContainerTypeReleasedInfo.vue";
import FactoryLoadingPlanHqPackingListInfoTable from "@/views/components/FactoryLoadingPlanHqPackingListInfoTable.vue";

import { getUsers, getUsersByJobPosition } from "@/api/users";
import {
  createCustomerOtherInfo,
  getCustomerOtherInfo,
} from "@/api/booking-order";
import { getRecipients } from "@/api/mails";

import { getPaymentTypes, getSettlementTypes } from "@/api/proforma";

@Component({
  name: "CustomerManagement",
  components: {
    FactoryLoadingPlanHqPackingListInfoTable,
    ContainerTypeReleasedInfo,
    Pagination,
  },
})
export default class extends Vue {
  public payload = new WriteShippingOrderInput();
  private customerList: WriteShippingOrderInput[] = [];
  private dialogFormVisible = false;
  private showAll = false;
  private showFileList = false;
  private files: File[] = [];
  private seller: User[] = []; //销售员
  private users: User[] = []; //销售助理
  private priceClass: PriceClass[] = []; //客人定价等级
  private logistics: User[] = []; //物流员

  private rule = {
    code: [{ required: true, message: "请输入客户编码", trigger: "blur" }],
    abbreviation: [
      { required: true, message: "请输入客户简称", trigger: "blur" },
    ],
  };

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "CNF", value: "3" },
    { label: "DPU", value: "4" },
  ];

  private paymentOptions = [];
  private paymentOptionsMethods = [];

  private ladingTypeOptions = [
    { label: "正本", value: "1" },
    { label: "SWB", value: "2" },
    { label: "电放", value: "3" },
    { label: "异地放单", value: "4" },
    { label: "铁路运单COPY", value: "6" },
    { label: "公路运单", value: "7" },
  ];
  created() {
    this.getPaymentTypes();
    this.getSettlementTypes();
  }

  private handleFilter() {
    if (this.listQuery.keyword === "showmealldata") {
      this.listQuery.keyword = "";
      this.getList();
      return;
    }
    if (this.listQuery.keyword && this.listQuery.keyword.length >= 3) {
      this.getList();
      return;
    }
    this.$message({
      message: "输入的客户简称或编号必须>=3位",
      type: "error",
    });
  }

  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    keyword: null,
    saleName: null,
  };

  private total = 0;
  private listLoading = false;
  private userList = [];

  private async getList() {
    this.listLoading = true;
    const params = { ...this.listQuery };
    const { content, total }: any = await searchCustomerAll(params);
    this.total = total;
    this.customerList = content;
    this.listLoading = false;
    this.userList = (await getRecipients({ pushType: "USER_PUSH" })) as any;
  }

  private getUserNameById(value) {
    for (let userListElement of this.userList) {
      if (userListElement.value == value) {
        return userListElement.label;
      }
    }
    return "";
  }

  private items: string[] = [];
  private customerId: string;
  private infoGroup: string;
  private editCustomerOtherInfoVisible = false;

  private async getCustomerOtherInfo(customerId: string, group: string) {
    this.customerId = customerId;
    this.infoGroup = group;
    let data: any = await getCustomerOtherInfo(customerId, "", group);
    this.items = data;
    this.editCustomerOtherInfoVisible = true;
  }

  private removeItem(item) {
    this.items = this.items.filter((value) => value !== item);
  }

  private async createCustomerOtherInfo() {
    await createCustomerOtherInfo(this.customerId, {
      group: this.infoGroup,
      infos: this.items,
    }).then(() => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
    });
    let value = this.items[0];
    switch (this.infoGroup) {
      case "FIVE_PIECES_SET_COMPANY_NAME":
        this.payload.fivePiecesSetCompanyName = value;
        break;
      case "FIVE_PIECES_SET_COMPANY_ADDRESS":
        this.payload.fivePiecesSetCompanyAddress = value;
        break;
      case "FIVE_PIECES_SET_COMPANY_OTHER_INFO":
        this.payload.fivePiecesSetCompanyOtherInfo = value;
        break;
      case "BL_COMPANY_NAME":
        this.payload.name = value;
        break;
      case "BL_COMPANY_ADDRESS":
        this.payload.address = value;
        break;
      case "BL_COMPANY_OTHER_INFORMATION":
        this.payload.tel = value;
        break;
      case "BL_NOTIFIER_COMPANY_NAME":
        this.payload.notifier = value;
        break;
      case "BL_NOTIFIER_ADDRESS":
        this.payload.notifierAddress = value;
        break;
      case "BL_NOTIFIER_ADDITIONAL_INFO":
        this.payload.blNotifyPersonInfo = value;
        break;
      case "IV_COMPANY_NAME":
        this.payload.ivCompanyName = value;
        break;
      case "IV_COMPANY_ADDRESS":
        this.payload.ivCompanyAddress = value;
        break;
      case "IV_COMPANY_OTHER_INFO":
        this.payload.ivCompanyInfo = value;
        break;
    }
    this.editCustomerOtherInfoVisible = false;
  }

  private addFile(file: File) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await uploadCustomer(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async handleUpload2() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await uploadCustomerPriceClass(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    if (this.listQuery.keyword && this.listQuery.keyword.length >= 3) {
      await this.getList();
      return;
    }
  }

  private async deleteCustomer(row) {
    deleteCustomer(row.id);
    await this.getList();
  }

  // 付款方式
  private async getPaymentTypes() {
    const res: any = await getPaymentTypes();
    this.paymentOptionsMethods = res;
  }

  // 结算方式
  private async getSettlementTypes() {
    const res: any = await getSettlementTypes();
    this.paymentOptions = res;
  }

  private async updateCustomer(row) {
    const response: any = await getCustomerEdit(row.code);
    console.log(response.priceClassId.id);
    let data_: any;
    data_ = await getUsersByJobPosition("logistics-clerk");
    this.logistics = data_;
    data_ = await getUsersByJobPosition("seller");
    this.seller = data_;
    data_ = await getAllPriceClass();
    this.priceClass = data_;

    const { content }: any = await getUsers({
      pageNumber: 1,
      pageSize: 2000,
    });
    data_ = content;
    this.users = data_;
    this.payload = response;
    this.payload.priceClassId = response.priceClassId.id;
    this.dialogFormVisible = true;
  }

  private async doUpdateData() {
    await createCustomerWhole(this.payload).then(() => {
      this.$notify({
        title: "成功",
        message: "更新成功",
        type: "success",
        duration: 2000,
      });
    });
    this.dialogFormVisible = false;
    await this.getList();
  }

  renderAbbr (prop,row){
    if (row.priceClassId && row.priceClassId.name) {
      return `[${row.priceClassId.name}]${prop}`
    }
    return prop
  }
}

export class Company {
  name: string;
  type: CompanyType;
}

class CompanyType {
  name: string;
  desc: string;

  constructor(name: string, desc: string) {
    this.name = name;
    this.desc = desc;
  }
}

class User {
  name: string;
  id: string;

  constructor(name: string, id: string) {
    this.name = name;
    this.id = id;
  }
}
class PriceClass {
  id: string;
  name: string;

  constructor(name: string, id: string) {
    this.name = name;
    this.id = id;
  }
}

class WriteShippingOrderInput {
  id: string;
  code: string; //客户编号
  name: string; //BL公司名
  abbreviation: string; //客户简称
  priceClassId: string; //客人定价等级
  address: string; //BL公司地址
  tel: string; //BL公司其他信息
  country: string; //客人国家
  departures: string; //出口港
  tradeCountry: string; //贸易国
  departure: string; //出境关别
  transportation: string; //运输方式
  destinationCountry: string; //最终目的国
  deliveryCountry: string; //运抵国
  portDischarge: string; //指运港
  internationalTradeTerms: string; //成交方式
  payment: string; //付款方式
  paymentDetails: string; //报关销售合同付款方式
  ladingType: string; //提单类型
  notifier: string; //BL通知人公司名
  notifierAddress: string; //BL通知人地址
  nation: string; //原产国
  continent: string; //洲
  district: string; //分区
  paymentMethod: string; //结算方式
  seller: string; //销售员
  auditor: string; //PI审核员
  sellerAssistant: string; //销售助理
  logistics: string; //物流员
  generalCode: string; // 客人通用编号
  generalAbbreviation: string; // 客人通用名称
  paymentName: string; //付款人名称
  accountPeriod: string; // 账期
  longTermDeposit: string; // 长期定金
  depositPercent: string; // 定金百分比
  groupCode: string; // 集团编号
  groupAbbreviation: string; // 集团简称
  blNotifyPersonInfo: string; // BL通知人其它信息
  ivCompanyName: string; // IV公司名
  ivCompanyAddress: string; // IV公司地址
  ivCompanyInfo: string; // IV公司其他信息
  expressCompanyName: string; // 快递公司名
  expressCompanyAddress: string; // 快递公司地址
  countryCode: string; // 国家代码
  paymentCompanyCountry: string; // 付款公司国家
  fivePiecesSetCompanyName: string; // 五件套公司名
  fivePiecesSetCompanyAddress: string; // 五件套公司地址
  fivePiecesSetCompanyOtherInfo: string; // 五件套公司其它信息
  paymentTerm: string;
}
